import { render, staticRenderFns } from "./AtributosBillingSequenceModal.vue?vue&type=template&id=bc073a8a"
import script from "./AtributosBillingSequenceModal.vue?vue&type=script&lang=js"
export * from "./AtributosBillingSequenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports